import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";

const PackagePrice = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    const [loadingg, setLoadingg] = useState(true);
    const [packages, setPackages] = useState([]);
    const [msg, setMsg] = useState("");

    const fetchDataPackages = async () => {
        setLoadingg(true);

        try {
            const headerss = {
                accept: "*/*",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "false",
                Authorization: "Bearer " + user.token
            };
            //const packageUrl = "https://localhost:7004/api/User/GetPackages";
            //const courseUrl = "https://localhost:7004/api/user/Opt/GetCourse";

            const packageUrl = "https://api.heryerdeingilizce.com/api/User/GetPackages";
            const courseUrl = "https://api.heryerdeingilizce.com/api/User/Content/GetCourse"; // user yerine User dene

            const [packageRes, courseRes] = await Promise.all([
                axios.get(packageUrl, { headers: headerss }),
                axios.get(courseUrl, { headers: headerss })
            ]);

            console.log("Package Response:", packageRes.data);
            console.log("Course Response:", courseRes.data);

            if (!(packageRes.status === 200 && packageRes.data.success)) {
                setMsg(packageRes.data.message || t("unexpectedError"));
                setLoadingg(false);
                return;
            }

            const courseMap = {};

            if (courseRes.status === 200 && courseRes.data.success) {
                const courseList = courseRes.data?.data?.courses || [];

                courseList.forEach((course) => {
                    courseMap[String(course.id)] = course.courseName;
                });
            }
            const filteredPackages = [];
            const packageList = packageRes.data?.data || [];

            for (let i = 0; i < packageList.length; i++) {
                const p = packageList[i];

                if (!p.isActive) continue;

                if (
                    (user.role === "Yönetici" && !p.isInvidual) ||
                    (user.role === "Öğrenci" && p.isInvidual)
                ) {
                    filteredPackages.push({
                        id: p.id,
                        packageName: p.packageName,
                        packageDetail: p.packageDetail,
                        packagePrice: p.packagePrice,
                        howManyDays: p.howManyDays,
                        courseName: courseMap[String(p.sortNumber)] || "-"
                    });
                }
            }

            setPackages(filteredPackages);
        } catch (err) {
            console.log("API ERROR:", err.response?.status, err.response?.data, err.config?.url);
            setMsg(err.response?.data?.message || err.message || t("unexpectedError"));
        }

        setLoadingg(false);
    };

    useEffect(() => {
        //getPackages();
        fetchDataPackages();
    }, []);

    return (
        <div className="container my-4 my-md-5">
            <div className="card shadow-sm border-0">
                <div className="card-body p-3 p-md-4">
                    <h3 className="text-center mb-2">{t("packages&prices")}</h3>
                    <p className="text-center text-muted mb-4">{t("packagesList")}</p>

                    {loadingg && (
                        <div className="alert alert-info text-center">
                            {t("loading")}...
                        </div>
                    )}

                    {!loadingg && msg && (
                        <div className="alert alert-warning text-center">
                            {msg}
                        </div>
                    )}

                    {!loadingg && !msg && (
                        <div className="table-responsive">
                            <table className="table table-hover table-bordered align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ minWidth: "70px" }}>{t("id")}</th>
                                        <th style={{ minWidth: "180px" }}>{t("packageName")}</th>
                                        <th style={{ minWidth: "220px" }}>{t("packageDescription")}</th>
                                        <th style={{ minWidth: "180px" }}>Course</th>
                                        <th style={{ minWidth: "130px" }}>{t("validityDate")}</th>
                                        <th style={{ minWidth: "130px" }}>{t("packagePrice")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {packages.map((dt) => (
                                        <tr key={dt.id}>
                                            <td className="fw-bold">{dt.id}</td>
                                            <td>{dt.packageName}</td>
                                            <td className="text-muted">{dt.packageDetail}</td>
                                            <td>
                                                <span dangerouslySetInnerHTML={{ __html: dt.courseName }} />
                                            </td>                                            <td>{dt.howManyDays}</td>
                                            <td>
                                                <span className="badge bg-success fs-6">
                                                    {dt.packagePrice}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {packages.length === 0 && (
                                <div className="alert alert-light text-center mb-0">
                                    {t("noData") || "Kayıt bulunamadı."}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PackagePrice;